module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust3.d9d4009f5bbd8d0a5cded024d93eb8ed.png";